'use strict';

import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Site } from '../sites';
import { routeData } from '../shared/route-helpers';

@Component({
    selector: 'investigator-header-title',
    template: require('./investigator-header-title.component.html'),
    styles: [require('./investigator-header-title.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestigatorHeaderTitleComponent {
    public sponsor: string;
    public clientProtocol: string;
    public covanceProjectNumber: string;
    public investigator: string;

    private subscription: Subscription;

    constructor(private route: ActivatedRoute, changeDetector: ChangeDetectorRef) {
        this.subscription = this.route.data
            .pipe(map(x => x[routeData.selectedSite] as Site))
            .subscribe(site => {
                this.sponsor = site.study.sponsor;
                this.clientProtocol = site.study.clientProtocol;
                this.covanceProjectNumber = site.study.covanceProjectNumber;
                this.investigator = site.investigatorFullName;
                changeDetector.markForCheck();
            });
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
